export const EDIT_CONTROL_REPO_START = 'EDIT_CONTROL_REPO_START';
export const EDIT_CONTROL_REPO_COMPLETE = 'EDIT_CONTROL_REPO_COMPLETE';
export const EDIT_CONTROL_REPO_ERROR = 'EDIT_CONTROL_REPO_ERROR';
export const EDIT_CONTROL_REPO_WEBHOOK_ERROR =
  'EDIT_CONTROL_REPO_WEBHOOK_ERROR';
export const CLOSE_MODAL = 'CLOSE_MODAL';
